
import React from "react";

import AddIcon from "@mui/icons-material/Add";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { MODALS } from "../../../config/params";
import { NewSecondaryButton } from "../../../styles/styledComponents";
import { PetCard } from "../../../components";
import { toastMessageActions } from "../../../state/request";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useDispatch } from "react-redux";
import { useModal } from "../../../context/ModalContext";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";

interface IExpressPetSelectionContainer{
  handleExpressWarning: ( petname: string) => void
}

const ExpressPetSelectionContainer = ({ handleExpressWarning }: IExpressPetSelectionContainer) => {
  const dispatch = useDispatch();
  const { petList: petsActive } = usePetStore();
  const { selectedPets, setSelectedPets, reasonForVisit, setReasonForVisit } =
    useAppointmentStore();
  const { openModal } = useModal();

  const handleSelectPet = (pet: IPetItemResponse) => {
    if (pet.isEligibleForExpressVisit) {
      if (selectedPets?.find((p: IPetItemResponse) => p.id === pet.id)) {
        setSelectedPets(
          selectedPets.filter((e: IPetItemResponse) => {
            return e.id !== pet.id;
          }),
        );
        const updatedReasonForVisits = { ...reasonForVisit };


        delete updatedReasonForVisits[pet.id];
        setReasonForVisit(updatedReasonForVisits);
      } else if (selectedPets.length < 3) {
        setSelectedPets([...selectedPets, pet]);
        setReasonForVisit({
          ...reasonForVisit,
          [pet.id]: { reasons: "", anything: " ", socReasons: [] },
        });
      } else if (selectedPets.length === 3) {
        dispatch(
          toastMessageActions.setGlobalAlert({
            severity: "error",
            message: "You can only book for three pets at a time.",
          }),
        );
      }
    } else {
      handleExpressWarning(pet.name);
    }
  };

  const handleClickAddAPet = () => {
    openModal(MODALS.ADD_A_PET);
  };

  return (
    <>
      <div
        className="p-4 w-full
      flex flex-col justify-between gap-4 border border-taupe-50 rounded-xl">
        <div className="flex flex-col gap-1">
          <div className="text-lg font-semibold">
          Which of your pets need to book an Express Services appointment?
          </div>
          <div className="text-sm text-gray-1">
            Select one or more pets to continue.
          </div>
        </div>
        <div className="bg-red-60">
          <div className="flex flex-col gap-3">
            {petsActive?.map((pet: IPetItemResponse) => (
              <a
                key={pet.id}
                className="w-full"
                onClick={() => handleSelectPet(pet)}
              >
                <PetCard
                  isActive={
                    !!selectedPets?.find((p: IPetItemResponse) => {
                      return p.id === pet.id;
                    })
                  }
                  image={pet.image}
                  pet={pet}
                  notBold={false}
                  displaySoc={true}
                  isDisabled={!pet.isEligibleForExpressVisit}
                />
              </a>
            ))}
            <div
              className="p-3 border border-taupe-50 rounded-2xl cursor-pointer"
              onClick={handleClickAddAPet}
            >
              <NewSecondaryButton startIcon={<AddIcon />}>
                Add Pet
              </NewSecondaryButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpressPetSelectionContainer;
